<template>
	<div class="auth-check" />
</template>

<script>
export default {
	name: "AuthCheck",
	methods: {
		/**
		 * Обработать проверку статуса авторизации
		 */
		async check() {
			const { token } = this.$context.authService.getUser()
			const status = token ? await this.$context.authService.check(token) : false

			return { status, token }
		},

		/**
		 * Обработать логин пользователя
		 * @param {Object} user
		 */
		async login(user) {
			console.log("auth:login", { user })

			const token = user.auth_token || null
			const status = await this.$context.authService.check(token)

			if (status) {
				const authUser = await this.$context.authService.getProfile(token)

				await this.$context.authService.setUser(authUser)
			}

			return { status, user }
		},

		/**
		 * Обработать разлогин пользователя
		 */
		async logout() {
			await this.$context.authService.logout()
		}
	},
	created() {
		// Установить обработчики
		this.$context.frameGateway.setHandlers({
			check: this.check.bind(this),
			login: this.login.bind(this),
			logout: this.logout.bind(this)
		})
	}
}
</script>

<style lang="scss" scoped>
.auth-check {
	// display: none;

	&__log {
		padding-bottom: 20px;
		margin-bottom: 20px;
		border-bottom: 3px solid #cccccc;
	}
}
</style>
